import { render, staticRenderFns } from "./DialogChargeDuplicate.vue?vue&type=template&id=b8438a56"
import script from "./DialogChargeDuplicate.vue?vue&type=script&lang=js"
export * from "./DialogChargeDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports